import { PageTypes } from 'core/constant/analytics/PageTypes';
import { MobilePageTypes } from 'core/constant/analytics/MobilePageTypes';
import { WebViewPageTypes } from 'core/constant/analytics/WebViewPageType';
import { BrowserInfo } from 'core/type/BootstrapConfig.types';
import { ActivitiesCombinedPageTypes, ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';

interface PageTypeByPlatform {
    mobile: MobilePageTypes;
    desktop: PageTypes;
    webview: WebViewPageTypes;
    previousPage: PageTypes;
}

type PageTypeMapType = {
    [key in PageTypes]: PageTypeByPlatform;
};

const PageTypeMap: PageTypeMapType = {
    [PageTypes.Unknown]: { mobile: MobilePageTypes.Unknown, desktop: PageTypes.Unknown, webview: WebViewPageTypes.Unknown, previousPage: PageTypes.Home },
    [PageTypes.Home]: { mobile: MobilePageTypes.Home, desktop: PageTypes.Home, webview: WebViewPageTypes.Home, previousPage: PageTypes.Home },
    [PageTypes.Search]: { mobile: MobilePageTypes.Search, desktop: PageTypes.Search, webview: WebViewPageTypes.Search, previousPage: PageTypes.Home },
    [PageTypes.Details]: { mobile: MobilePageTypes.Details, desktop: PageTypes.Details, webview: WebViewPageTypes.Details, previousPage: PageTypes.Search },
    [PageTypes.Login]: { mobile: MobilePageTypes.Login, desktop: PageTypes.Login, webview: WebViewPageTypes.Login, previousPage: PageTypes.Home },
    [PageTypes.BookingForm1]: { mobile: MobilePageTypes.BookingForm1, desktop: PageTypes.BookingForm1, webview: WebViewPageTypes.BookingForm1, previousPage: PageTypes.Search },
    [PageTypes.BookingForm2]: { mobile: MobilePageTypes.BookingForm2, desktop: PageTypes.BookingForm2, webview: WebViewPageTypes.BookingForm2, previousPage: PageTypes.Search },
    [PageTypes.ThankYou]: { mobile: MobilePageTypes.ThankYou, desktop: PageTypes.ThankYou, webview: WebViewPageTypes.ThankYou, previousPage: PageTypes.Search },
    [PageTypes.PageNotFound]: { mobile: MobilePageTypes.PageNotFound, desktop: PageTypes.PageNotFound, webview: WebViewPageTypes.PageNotFound, previousPage: PageTypes.Home },
    [PageTypes.City]: { mobile: MobilePageTypes.City, desktop: PageTypes.City, webview: WebViewPageTypes.City, previousPage: PageTypes.Home },
    [PageTypes.Country]: { mobile: MobilePageTypes.Country, desktop: PageTypes.City, webview: WebViewPageTypes.Country, previousPage: PageTypes.Home },
    [PageTypes.Region]: { mobile: MobilePageTypes.Region, desktop: PageTypes.Region, webview: WebViewPageTypes.Region, previousPage: PageTypes.Home },
    [PageTypes.Area]: { mobile: MobilePageTypes.Area, desktop: PageTypes.Area, webview: WebViewPageTypes.Area, previousPage: PageTypes.Home },
};

const getPageTypeInternal = (browser: BrowserInfo, pageTypeMap: PageTypeMapType, pageType: PageTypes) => {
    const targetPageType = pageTypeMap[pageType];
    if (!targetPageType) {
        return PageTypes.Unknown;
    }
    if (browser.isWebView) {
        return targetPageType.webview;
    }
    if (browser.isMobile) {
        return targetPageType.mobile;
    }
    return targetPageType.desktop;
};

export const getPageType = (browser: BrowserInfo, pageType: PageTypes): ActivitiesPageTypes => {
    return getPageTypeInternal(browser, PageTypeMap, pageType);
};

export const getPreviousPageType = (browser: BrowserInfo, pageType: ActivitiesPageTypes): ActivitiesPageTypes => {
    const internalPageType = ActivitiesCombinedPageTypes[pageType];
    const currentPageType = PageTypeMap[internalPageType] ?? PageTypeMap[PageTypes.Unknown];
    const previousPageType = getPageTypeInternal(browser, PageTypeMap, currentPageType.previousPage);
    return previousPageType;
};
